import DataBuilder from '../DataBuilder'

const download = (name: string, content: string) => {
    const a = document.createElement('a')
    a.href = content
    a.download = name
    a.click()
}

const withExtension = (name: string, ext: string) => {
    if (!ext) return name
    ext = ext.startsWith('.') ? ext : '.' + ext
    return name.endsWith(ext) ? name : `${name}${ext}`
}

export const downloadPng = (name: string, content: string) =>
    download(withExtension(name, 'png'), content)

export const downloadJson = (name: string, content: string) =>
    download(withExtension(name, 'json'), new DataBuilder(content).json().utf8().toString())

export const downloadPdf = (name: string, content: string) =>
    download(withExtension(name, 'pdf'), new DataBuilder(content).pdf().base64().toString())

export const downloadText = (name: string, content: string, extension: string = 'txt') =>
    download(withExtension(name, extension), new DataBuilder(content).toString())

export const downloadBlob = (filename: string, content: Blob, extension: string) => {
    const a = document.createElement('a')
    const url = URL.createObjectURL(content)

    a.href = url
    a.download = `${filename}.${extension}`
    a.click()

    URL.revokeObjectURL(url)
}
